import { useLazyQuery, LazyQueryHookOptions } from "@apollo/client";
import { CheckVatQuery, CheckVatQueryVariables } from "@whoppah/apollo/schema";
import useCheckVatQuery from "@whoppah/apollo/query/checkVat.graphql";

const useCheckVatLazy = (
  options?: LazyQueryHookOptions<CheckVatQuery, CheckVatQueryVariables>
) => {
  return useLazyQuery(useCheckVatQuery, options);
};

export default useCheckVatLazy;
